import { render, staticRenderFns } from "./AccountSettingModal.vue?vue&type=template&id=5a712e93&scoped=true"
import script from "./AccountSettingModal.vue?vue&type=script&lang=js"
export * from "./AccountSettingModal.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingModal.vue?vue&type=style&index=0&id=5a712e93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a712e93",
  null
  
)

export default component.exports